<template>
  <div app fixed>
    <!-- <v-layout row justify-space-between ma-0 class="input-container"> ,marginTop:isTextFieldFocused && isiOS ?'-360px':''-->
    <v-layout row justify-space-between ma-0 class="input-container">
      <div class="container">
        <div class="select-panel">
          <div
            v-bind:key="index"
            v-show="isShow"
            v-for="(w, index) in words"
            class="select-item"
            @click="click_item(words[index])"
          >
            <!-- {{ words[index] }} -->
            <div v-html="highlight(words[index])"></div>
          </div>
        </div>

        <div ref="textInput1" class="textInput1">
          <v-toolbar
            color="white"
            v-bind:dense="this.$store.state.isRunningEmbedded"
            flat
            :style="{
              height: this.isiOS ? '18vw' : '18vw',
            }"
          >
            <!--   'padding-bottom': 'env(safe-area-inset-bottom)'
          using v-show instead of v-if to make recorder-status transition work  
            single-line
        -->
            <!--      ref="textInput" <div class="styleChange"> -->

            <div
              class="styleChange"
              ref="textInput"
              :style="{ width: this.clientWidth - 70 + 'px' }"
            >
              <!-- <div class="container"> -->

              <v-text-field
                v-show="shouldShowTextInput"
                v-bind:disabled="isLexProcessing"
                v-model="textInput"
                v-on:keyup.enter.stop="postTextMessage"
                v-on:focus="onTextFieldFocus"
                v-on:blur="onTextFieldBlur"
                v-on:keyup.enter.delete="onEnter"
                @input="debounceInput"
                id="text-input"
                name="text-input"
                single-line
                hide-details
                :style="{ top: '2.5vw' }"
              >
                <template v-slot:label>
                  <div class="placeholder">
                    {{ $t("licence.Robot_TypeHere") }}
                  </div>
                </template>

                <!-- :style="{'color':isTextFieldFocused ? 'red' :'blue'}" -->
              </v-text-field>

              <!-- </div> -->
              <recorder-status v-show="!shouldShowTextInput"></recorder-status>

              <v-tooltip
                activator=".input-button"
                content-class="tooltip-custom"
                v-model="shouldShowTooltip"
                ref="tooltip"
                left
              >
                <span id="input-button-tooltip">{{ inputButtonTooltip }}</span>
              </v-tooltip>
              <v-tooltip
                activator=".end-live-chat-button"
                content-class="tooltip-custom"
                v-model="shouldShowEndLiveChatTooltip"
                ref="tooltipEndLiveChat"
                left
              >
                <span id="input-button-tooltip">End Live Chat</span>
              </v-tooltip>

              <!-- <v-icon
            class="components-icon components-record"
            style="height: 30px; width: 30px; "
          /> -->

              <v-dialog
                class="test2"
                content-class="vdialognew"
                attach="vdialognew"
                v-model="showMenu"
              >
                <v-card class="menuCard">
                  <!-- <v-card-title>Select Country</v-card-title> -->
                  <!-- <v-divider></v-divider> -->
                  <v-card-text>
                    <div class="menuContainer">
                      <div class="menuBtn" v-on:click="Faq(0)">
                        <div class="menu">
                          <img
                            :src="require('../assets/appMigration@2x.png')"
                            width="23vw"
                            height="23vw"
                            :style="{ 'margin-right': '2vw' }"
                          />
                          <div style="color: #333333">App Migration</div>
                        </div>
                      </div>
                      <v-divider style="
    background-color: #EEEEEE;
"></v-divider>
                      <div class="line"></div>
                      <div class="menuBtn" v-on:click="Faq(1)">
                        <div class="menu">
                          <img
                            :src="require('../assets/appOperation@2x.png')"
                            width="23vw"
                            height="23vw"
                            :style="{ 'margin-right': '2vw' }"
                          />
                          <v-text style="color: #333333">App Operation</v-text>
                        </div>
                      </div>
                      <v-divider style="
    background-color: #EEEEEE;
"></v-divider>
                      <div class="menuBtn" v-on:click="Faq(2)">
                        <div class="menu">
                          <img
                            :src="require('../assets/deviceProblems@2x.png')"
                            width="23vw"
                            height="23vw"
                            :style="{ 'margin-right': '2vw' }"
                          />
                          <v-text style="color: #333333"
                            >Device Problems</v-text
                          >
                        </div>
                      </div>
                      <v-divider style="
    background-color: #EEEEEE;
"></v-divider>
                      <div class="menuBtn" v-on:click="Faq(3)">
                        <div class="menu">
                          <img
                            :src="require('../assets/helpCenter@2x.png')"
                            width="23vw"
                            height="23vw"
                            :style="{ 'margin-right': '2vw' }"
                          />
                          <v-text style="color: #333333">Help Center</v-text>
                        </div>
                      </div>
                      <!-- <v-divider></v-divider> -->
                    </div>
                  </v-card-text>
                  <!-- <v-divider></v-divider> -->
                </v-card>
              </v-dialog>

              <v-btn
                v-if="isModeLiveChat"
                v-on:click="onEndLiveChatClick"
                v-on="tooltipEndLiveChatEventHandlers"
                ref="endLiveChat"
                class="end-live-chat-button"
                aria-label="End Live Chat"
              >
                <v-icon medium>call_end</v-icon>
              </v-btn>
            </div>

            <!-- 样式更改 -->
            <!--   aria-label="Send Message"   ref="send"    v-on="tooltipEventHandlers" -->
            <v-btn
              v-if="shouldShowSendButton"
              v-on:click="postTextMessage"
              v-bind:disabled="isLexProcessing"
           
              class="icon-color input-button"
              dark
              @touchstart="subtouchStart($event, index)"
              icon
              
             
            >
              <!-- <v-icon medium>send</v-icon> -->

              <!-- <img
                  v-if="!isTextFieldFocused"
                  :src="require('../assets/sendmsg@2x.png')"
                  :style="{
                    width: '9vw',
                    height: '9vw',
                  }"
                />
            -->

              <img
                :src="require('../assets/sendmsgL@2x.png')"
                :style="{
                  width: '9vw',
                  height: '9vw',
                  marginTop: '2vw',
                }"
              />
            </v-btn>
            <v-btn
              v-if="!shouldShowSendButton && !isModeLiveChat"
              v-on:click="onMsgClick"
              v-bind:disabled="isMicButtonDisabled"
              ref="mic"
              class="icon-color input-button"
              icon
              dark
            >
              <!-- <v-icon medium>{{micButtonIcon}}</v-icon> -->

              <!-- <img
                  v-if="!isTextFieldFocused"
                  :src="require('../assets/sendmsg@2x.png')"
                  :style="{
                    width: '9vw',
                    height: '9vw',
                  }"
                />
           -->

              <img
                :src="require('../assets/more@2x.png')"
                :style="{
                  width: '9vw',
                  height: '9vw',
                  marginTop: '2vw',
                }"
              />
            </v-btn>
            <!-- separate tooltip as a workaround to support mobile touch events -->
            <!-- tooltip should be before btn to avoid right margin issue in mobile -->
          </v-toolbar>
        </div>
      </div>
    </v-layout>
  </div>
</template>

<script>
/*
Copyright 2017-2019 Amazon.com, Inc. or its affiliates. All Rights Reserved.

Licensed under the Amazon Software License (the "License"). You may not use this file
except in compliance with the License. A copy of the License is located at

http://aws.amazon.com/asl/

or in the "license" file accompanying this file. This file is distributed on an "AS IS"
BASIS, WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, express or implied. See the
License for the specific language governing permissions and limitations under the License.
*/
/* eslint no-console: ["error", { allow: ["warn", "error"] }] */

import RecorderStatus from "@/components/RecorderStatus";
import toast from "../components/myToast/index";
import update from "../api/history";
import Bus from "./bus.js";

export default {
  name: "input-container",
  data() {
    return {
      flag: 0,
      debounceInput: () => {},
      translateTexts: "wie machen",
      LanguageCode: "en",
      showMenu: false,
      msg: "",
      newVals: "",
      // words: ["a", "b", "c", "d", "e"],
      words: [],
      isShow: false,
      temp: 0,
      furl: "https://cdn.pixabay.com/photo/2014/12/16/22/25/woman-570883_960_720.jpg",
      rs: 0,
      prevrs: 0,
      Bottomheight: 0,
      clientWidth: document.documentElement.clientWidth,
      isiOS: false,
      scrollint: null,
      onLine: navigator.onLine,
      textInput: "",
      isTextFieldFocused: false,
      shouldShowTooltip: false,
      shouldShowEndLiveChatTooltip: false,
      // workaround: vuetify tooltips doesn't seem to support touch events
      tooltipEventHandlers: {
        mouseenter: this.onInputButtonHoverEnter,
        mouseleave: this.onInputButtonHoverLeave,
        touchstart: this.onInputButtonHoverEnter,
        touchend: this.onInputButtonHoverLeave,
        touchcancel: this.onInputButtonHoverLeave,
      },
      tooltipEndLiveChatEventHandlers: {
        mouseenter: this.onEndLiveChatButtonHoverEnter,
        mouseleave: this.onEndLiveChatButtonHoverLeave,
        touchstart: this.onEndLiveChatButtonHoverEnter,
        touchend: this.onEndLiveChatButtonHoverLeave,
        touchcancel: this.onEndLiveChatButtonHoverLeave,
      },
    };
  },
  props: ["textInputPlaceholder", "initialSpeechInstruction"],
  components: {
    RecorderStatus,
  },
  mounted() {
    this.debounceInput = this.debounce(this.onKeyUp, 500, false);
    window.addEventListener("touchmove", this.myTouchmove);
    window.addEventListener("online", this.updateOnlineStatus);
    window.addEventListener("offline", this.updateOnlineStatus);
    let u = navigator.userAgent,
      app = navigator.appVersion;
    this.isiOS = !!u.match(/\(i[^;]+;( U;)? CPU.+Mac OS X/); //ios终端
    window.textFieldHight = this.textFieldHight;
    window.handleAppStateDidChange = this.handleAppStateDidChange;
    console.log("window.innerHeight---", document.documentElement.offsetHeight);
    // console.log(
    //   "costant(safe-area-inset-bottom)",
    //   safe - area - inset - bottom
    // );

    // if (isiOS) {
    //   $("text-input").focus(function () {
    //     console.log("99---");
    //     window.setTimeout(this.scrollBottom, 500);
    //   });
    // }

    //  const that = this;
    //    that.styleChange.height = window.innerHeight + "px"; // 屏幕高度
    //    that.styleChange.width = document.body.clientWidth+'px'; // 屏幕宽度
    //    console.log("高度", that.styleChange.height);
    //    console.log("宽度",  that.styleChange.width);
  },
  beforeDestroy() {
    window.removeEventListener("online", this.updateOnlineStatus);
    window.removeEventListener("offline", this.updateOnlineStatus);
    window.removeEventListener("touchmove", this.myTouchmove);
  },
  watch: {
    textInput: {
      handler: function (newVal, oldVal) {
        this.newVals = newVal;
        if (newVal === "") {
          this.isShow = false;
        }
        console.log(
          "newValoldVal---",
          newVal,
          "---",
          this.newVals,
          "---",
          oldVal,
          newVal === ""
        );
      },
    },
  },
  computed: {
    isBotSpeaking() {
      return this.$store.state.botAudio.isSpeaking;
    },
    isLexProcessing() {
      return this.$store.state.lex.isProcessing;
    },
    isSpeechConversationGoing() {
      return this.$store.state.recState.isConversationGoing;
    },
    isMicButtonDisabled() {
      return this.isMicMuted;
    },
    isMicMuted() {
      return this.$store.state.recState.isMicMuted;
    },
    isRecorderSupported() {
      return this.$store.state.recState.isRecorderSupported;
    },
    isRecorderEnabled() {
      return this.$store.state.recState.isRecorderEnabled;
    },
    isSendButtonDisabled() {
      return this.textInput.length < 1;
    },
    isModeLiveChat() {
      return this.$store.state.chatMode === "livechat";
    },
    micButtonIcon() {
      if (this.isMicMuted) {
        return "mic_off";
      }
      if (this.isBotSpeaking || this.isSpeechConversationGoing) {
        return "stop";
      }
      return "mic";
    },
    inputButtonTooltip() {
      if (this.shouldShowSendButton) {
        return "send";
      }
      if (this.isMicMuted) {
        return "mic seems to be muted";
      }
      if (this.isBotSpeaking || this.isSpeechConversationGoing) {
        return "interrupt";
      }
      return "click to use voice";
    },
    shouldShowSendButton() {
      return (
        (this.textInput.length && this.isTextFieldFocused) ||
        !this.isRecorderSupported ||
        !this.isRecorderEnabled
      );
    },
    shouldShowTextInput() {
      return !(this.isBotSpeaking || this.isSpeechConversationGoing);
    },
  },

  directives: {
    preventReClick: {
      inserted(el, binding) {
        el.addEventListener("click", () => {
          if (!el.disabled) {
            el.disabled = true;
            setTimeout(() => {
              el.disabled = false;
            }, binding.value || 3000);
          }
        });
      },
    },
  },
  methods: {
    Faq(index) {
      this.showMenu = false;

      if (this.onLine === false) {
        // toast({ text: this.$t("licence.key_internet_error"), time: 1000 });
        if (window.webkit != undefined) {
          let text = this.$t("licence.key_internet_error");
          window.webkit.messageHandlers.showToast.postMessage(text);
        } else {
          let text = this.$t("licence.key_internet_error");
          feedback.showToast(text);
        }
      } else {
        console.log("Faq----", index);
        // this.dynamic = index;
        let val;
        switch (index) {
          case 0:
            val = "App migration related issues";
            break;
          case 1:
            val = "APP Operation related issues";
            break;
          case 2:
            val = "Device Problems";
            break;
          case 3:
            val = "Help Center";
            break;
        }

        console.log("Faq----", index);
        const message = {
          type: "human",
          text: val,
        };
        this.$store.dispatch("postTextMessage", message);
        console.log("事件---", val);
        // return val;
      }
    },
    highlight(text) {
     
      // let val = this.textInput.replace(/,/g, "");
      // this.textInput = val.replace(/(\d{1,3})(?=(\d{3})+$)/g, "$&,");
      // 匹配关键字正则
       let replaceReg = new RegExp(this.textInput, 'igm')
       const replaceString = `<div style="color:blue;display: contents;">$&</div>`;
      // const reg = new RegExp(this.textInput, "gi");

      console.log("highlight--", text);
      return text.replace(replaceReg, replaceString);
    },
    debounce(func, delay = 1000, immediate = false) {
      //闭包
      let timer = null;
      //不能用箭头函数
      return function () {
        if (timer) {
          clearTimeout(timer);
        }
        if (immediate && !timer) {
          func.apply(this, arguments);
        }
        timer = setTimeout(() => {
          func.apply(this, arguments);
        }, delay);
      };
    },
    click_item(w) {
      console.log("click word", w);
      const message = {
        type: "human",
        text: w,
      };
      this.isShow = false;
      return this.$store.dispatch("postTextMessage", message).then(() => {
        // this.textInput = "";
        if (this.shouldShowTextInput) {
          this.setInputTextFieldFocus();
        }
      });
    },

    handleAppStateDidChange(param) {
      console.log("handleAppStateDidChange---", param);
      if (param) {
        console.log("9999");
        const inputid = document.getElementById("text-input");
        inputid.blur();
      }
    },

    textFieldHight(param) {
      //  console.log("result--==",typeof(param),param);
      const u = navigator.userAgent;
      const isiOS = !!u.match(/\(i[^;]+;( U;)? CPU.+Mac OS X/); //ios终端
      const result = JSON.parse(param);

      if (this.isiOS) {
        console.log("result-22-==", param);

        // this.Bottomheight = param;

        console.log("temp-4--", this.temp);
        if (this.temp == 0) {
          this.temp = result;
          console.log("temp-3--", this.temp);
        } else if (this.temp <= param) {
          console.log("preves---", this.temp, param, this.prevrs, this.rs);
          this.rs = param - this.temp;
          this.temp = param;
          // if (this.rs !== 0) {
          // this.rs += this.prevrs;
          console.log("rs---prev--", this.prevrs, this.rs);
          // }
        } else {
          this.temp = param;
          this.rs = this.temp - param;
        }
        this.$refs.textInput1.style.marginBottom = this.rs / 2 + "px";

        console.log("temp--param--rs--", this.temp, param, this.rs);
        this.prevrs = this.rs;
        this.rs = 0;
      }
    },
    //  防抖
    throttle(fn, delay = 3000) {
      //距离上一次的执行时间
      let lastTime = 0;
      return function () {
        let _this = this;
        let _arguments = arguments;
        let now = new Date().getTime();
        //如果距离上一次执行超过了delay才能再次执行
        if (now - lastTime > delay) {
          fn.apply(_this, _arguments);
          lastTime = now;
        }
      };
    },

    myTouchmove() {
      if (this.isTextFieldFocused) {
        const inputid = document.getElementById("text-input");
        inputid.blur();
        console.log("     this.isTextFieldFocused = false;");
      }
    },
    scrollBottom() {
      // window.scrollTo(0, '300px');
      // document.getElementById("container").scrollIntoView(true);
      window.scrollTo(0, "300px");
    },

    updateOnlineStatus(e) {
      const { type } = e;
      this.onLine = type === "online";
    },
    onInputButtonHoverEnter() {
      this.shouldShowTooltip = true;
    },
    onInputButtonHoverLeave() {
      this.shouldShowTooltip = false;
    },
    onEndLiveChatButtonHoverEnter() {
      this.shouldShowEndLiveChatTooltip = true;
    },
    onEndLiveChatButtonHoverLeave() {
      this.shouldShowEndLiveChatTooltip = false;
    },
    onMicClick() {
      this.onInputButtonHoverLeave();
      if (this.isBotSpeaking || this.isSpeechConversationGoing) {
        return this.$store.dispatch("interruptSpeechConversation");
      }
      if (!this.isSpeechConversationGoing) {
        return this.startSpeechConversation();
      }

      return Promise.resolve();
    },
    onMsgClick() {
      this.showMenu = true;
      this.isShow = false;
      console.log("onMsgClick--", this.showMenu);
      this.isTextFieldFocused = false;
      this.$emit("isTextFieldFocused", this.isTextFieldFocused);
      if (this.onLine === false) {
        // toast({ text: this.$t("licence.key_internet_error"), time: 1000 });
        if (window.webkit != undefined) {
          let text = this.$t("licence.key_internet_error");
          window.webkit.messageHandlers.showToast.postMessage(text);
        } else {
          let text = this.$t("licence.key_internet_error");
          feedback.showToast(text);
        }
      } else {
        this.isTextFieldFocused = true;
        console.log("textinput--", this.onLine);
        // if (this.textInput.length < 1) {
        //   if (window.webkit != undefined) {
        //     let text = this.$t("licence.Robot_emptyMassege_reminder");
        //     window.webkit.messageHandlers.showToast.postMessage(text);
        //   } else {
        //     let text = this.$t("licence.Robot_emptyMassege_reminder");
        //     feedback.showToast(text);
        //   }
        //   console.log("isSendButtonDisabled--", this.textInput.length < 1);
        // }
      }
    },
    downloadIamge(imgsrc, name) {
      //下载图片地址和图片名
      var image = new Image();
      // 解决跨域 Canvas 污染问题
      image.src = imgsrc + "?v=" + Math.random(); // 处理缓存
      image.crossOrigin = "*"; // 支持跨域图片
      image.onload = function () {
        var canvas = document.createElement("canvas");
        canvas.width = image.width;
        canvas.height = image.height;
        var context = canvas.getContext("2d");
        context.drawImage(image, 0, 0, image.width, image.height);
        var url = canvas.toDataURL("image/png"); //得到图片的base64编码数据

        var a = document.createElement("a"); // 生成一个a元素
        var event = new MouseEvent("click"); // 创建一个单击事件
        a.download = name || "img"; // 设置图片名称
        a.href = url; // 将生成的URL设置为a.href属性
        a.dispatchEvent(event); // 触发a的单击事件
        console.log("q====", a.dispatchEvent(event));
      };
    },

    onTextFieldFocus() {
      //  this.isShow = true
      this.flag = 0;
      //   onst Url = "https://cdn.pixabay.com/photo/2014/12/16/22/25/woman-570883_960_720.jpg"; //图片路径，也可以传值进来
      // let triggerEvent = "touchstart"; //指定下载方式
      //   let blob=new Blob([''], {type:'application/octet-stream'}); //二进制大型对象blob
      //   let url = URL.createObjectURL(blob); //创建一个字符串路径空位
      //   let a = document.createElement('a'); //创建一个 a 标签
      //   a.href = Url;  //把路径赋到a标签的href上
      //   //正则表达式，这里是把图片文件名分离出来。拿到文件名赋到a.download,作为文件名来使用文本
      //   a.download = Url.replace(/(.*\/)*([^.]+.*)/ig,"$2").split("?")[0];
      //   /* var e = document.createEvent('MouseEvents');  //创建事件（MouseEvents鼠标事件）
      //   e.initMouseEvent('click', true, false, window, 0, 0, 0, 0, 0, false, false, false, false, 0, null); //初始化鼠标事件（initMouseEvent已弃用）*/

      //   //代替方法。创建鼠标事件并初始化（后面这些参数我也不清楚，参考文档吧 https://developer.mozilla.org/en-US/docs/Web/API/MouseEvent/MouseEvent）
      // let e = new MouseEvent('click', ( true, false, window, 0, 0, 0, 0, 0, false, false, false, false, 0, null));
      // //派遣后，它将不再执行任何操作。执行保存到本地
      //   a.dispatchEvent(e);
      //   //释放一个已经存在的路径（有创建createObjectURL就要释放revokeObjectURL）
      //   URL.revokeObjectURL(url);

      // this.downloadIamge(this.furl, new Date().getTime());

      const element = document.getElementById("text-input");
      // if(this.isiOS){
      //   console.log('window.innerHeight---',document.documentElement.offsetHeight)
      //   //  document.documentElement.clientHeight = 300 + 'px',
      // this.$refs.textInput1.style.marginBottom = this.Bottomheight + "pt",
      // console.log("textInput1--",  this.$refs.textInput1.style.marginBottom ,this.Bottomheight);

      //   this.$refs.textInput.style.position = 'relative',

      //   element.scrollIntoView();

      // }
      // this.$emit("isTextFieldFocused",this.isTextFieldFocused);
      // console.log("888--");

      // window.scrollTo('300px',0)
      // activeElementScrollIntoView($text-input, 1000);
      // window.setTimeout(this.scrollBottom, 300);

      this.isTextFieldFocused = true;
      this.$emit("isTextFieldFocused", this.isTextFieldFocused);
    },
    onTextFieldBlur() {
      console.log('blur');
      // setTimeout(() => {
      this.isShow = false;
      // }, 200);
      this.flag = 1;
      if (this.isiOS) {
        this.$refs.textInput1.style.marginBottom = 0 + "px";
      }

      if (!this.textInput.length && this.isTextFieldFocused) {
        this.isTextFieldFocused = false;
      }
      // this.$emit("isTextFieldFocused", this.isTextFieldFocused);
    },
    onEnter() {
      console.log("onEnter-");
      if (this.textInput.length === 0) {
        this.isShow = false;
        this.words = [];
        console.log("msg---", this.textInput.length);
        // return;
      }
    },
    onKeyUp() {
      this.$store.dispatch("sendTypingEvent");
      if (this.textInput.length === 0) {
        this.isShow = false;
        this.words = [];
        console.log("msg---", this.textInput.length);
        return;
      }
      this.requestQuestion();
    },

    requestQuestion() {
      console.log("search msg", this.textInput);
      // this.isTextFieldFocused = false;
      // this.$emit("isTextFieldFocused", this.isTextFieldFocused);
      var AWS = require("aws-sdk");
      let that = this;
      let oneArr = [];
      let allArr = [];
      let translate = new AWS.Translate({ apiVersion: "2017-07-01" });
      let comprehend = new AWS.Comprehend({
        apiVersion: "2017-11-27",
        region: "us-east-1",
      });
      let kendra = new AWS.Kendra({
        apiVersion: "2019-02-03",
        region: "us-east-1",
        // credentials: AWS.config.credentials,
      });
      let params = {
        Text: that.textInput /* required */,
      };
      comprehend.detectDominantLanguage(params, function (err, data) {
        if (err) console.log("comprehend-err-", err, err.stack);
        // an error occurred
        else {
          that.LanguageCode = data.Languages[0].LanguageCode;
          console.log(
            "comprehend--",
            data.Languages[0].LanguageCode,
            that.textInput
          );
        }
        // successful response
      });

      let params1 = {
        SourceLanguageCode: that.LanguageCode /* required */,
        TargetLanguageCode: "en" /* required */,
        Text: that.textInput /* required */,
        Settings: {
          Formality: "FORMAL",
          Profanity: "MASK",
        },

        // TerminologyNames: [
        //   'German',
        //   /* more items */
        // ]
      };
      console.log("params1---", params1, params1.Text);
      if (that.textInput != null || "") {
        translate.translateText(params1, function (err, data) {
          if (err) console.log(err, err.stack);
          // an error occurred
          else {
            console.log(
              "data.TranslatedText---",
              that.translateTexts,
              data.TranslatedText
            );
            that.translateTexts = data.TranslatedText;
            let params2 = {
              IndexId: "c040725b-de97-4e3e-874d-5c91ac586086" /* required */,
              QueryText: that.translateTexts /* required */,
              MaxSuggestionsCount: 5,
            };
            console.log("msg2---", that.textInput.length);

            kendra.getQuerySuggestions(params2, function (err, data) {
              console.log(
                " kendra datafirst--",
                params2,
                that.words,
                that.isShow
              );
              if (err) console.log("err--", err, err.stack);
              // an error occurred
              else {
                // let that = this;
                // this.isShow = true;

                const result = data.Suggestions;

                console.log(" kendra dataafter--", data.Suggestions); // successful response

                for (const key in result) {
                  if (Object.prototype.hasOwnProperty.call(result, key)) {
                    console.log("Text--", result[key].Value.Text.Text); // successful response
                    // console.log('Textall---', result[key].Value.Text.Text.allAr)
                    // let params3 = {
                    //   SourceLanguageCode: "en" /* required */,
                    //   TargetLanguageCode: that.LanguageCode /* required */,
                    //   Text: result[key].Value.Text.Text /* required */,
                    //   Settings: {
                    //     Formality: "FORMAL",
                    //     Profanity: "MASK",
                    //   },
                    // };

                    // translate.translateText(params3, function (err, data) {
                    //   if (err) console.log(err, err.stack);
                    //   // an error occurred
                    //   else {
                    //     console.log("translateText--", data.TranslatedText);
                    oneArr.push(result[key].Value.Text.Text);
                    //     // that.words = that.words.concat(data.TranslatedText);
                    //     console.log("allArr--", oneArr);
                    //     console.log('all---',  that.words.concat(oneArr))
                    //   } // successful response

                    // });
                    // console.log('result--', result[key].Value.Text.Text)
                  }
                }
                let test7 = "";
                for (let i = 0; i < oneArr.length; i++) {
                  test7 += oneArr[i] + ",";
                }
                console.log("test7---", test7);
                let params3 = {
                  SourceLanguageCode: "en" /* required */,
                  TargetLanguageCode: that.LanguageCode /* required */,
                  Text: test7 /* required */,
                  Settings: {
                    Formality: "FORMAL",
                    Profanity: "MASK",
                  },
                };
                translate.translateText(params3, function (err, data) {
                  if (err) console.log(err, err.stack);
                  // an error occurred
                  else {
                    console.log("translateText--", data.TranslatedText);
                    let test9 = data.TranslatedText.split(",");
                    test9.pop();
                    console.log('this.flag ', that.flag )
                    if(that.flag === 0) {
                      that.words = test9;
                    }
                    
                    if (that.newVals !== "") {
                      console.log("newValoldVal---", that.newVals);
                      that.isShow = true;
                    }
                    console.log("test9----", test9);
                    // allArr = test9;
                    console.log(
                      "allArr----",
                      allArr,
                      typeof allArr,
                      oneArr,
                      typeof oneArr
                    );

                    // allArr.push(data.TranslatedText);
                    // that.words = that.words.concat(data.TranslatedText);
                    // console.log("allArr--", oneArr);
                    // console.log('all---',  that.words.concat(oneArr))
                  } // successful response
                });
                // }

                // console.log("allArr2--", oneArr,);

                console.log(
                  "allkendra data--",
                  data.Suggestions,
                  that.words,
                  oneArr,
                  that.isShow
                ); // successful response
              }

              // successful response
            });
          }
        });
      }

      // allArr.concat(oneArr);

      //  that.words = allArr;

      // allArr = [...words, ...oneArr];
      // console.log('this.translateTexts--', this.translateTexts);
      console.log(" kendra data--", this.$lexWebUi.awsConfig.credentials);
    },

    setInputTextFieldFocus() {
      // focus() needs to be wrapped in setTimeout for IE11
      setTimeout(() => {
        if (this.$refs && this.$refs.textInput && this.shouldShowTextInput) {
          // document.getElementById("lex-app").scrollIntoView();
          // window.scrollTo('200px',0)
          // this.$refs.textInput.$refs.input.focus();
        }
      }, 10);
    },
    playInitialInstruction() {
      const isInitialState = ["", "Fulfilled", "Failed"].some(
        (initialState) => this.$store.state.lex.dialogState === initialState
      );

      return this.$store.state.isLoggedIn &&
        isInitialState &&
        this.initialSpeechInstruction.length > 0
        ? this.$store.dispatch(
            "pollySynthesizeSpeech",
            this.initialSpeechInstruction
          )
        : Promise.resolve();
    },
    menu() {
      console.log("menu---");
    },
    postTextMessage() {
      this.isShow = false;
      console.log("postTextMessage---");
      this.isTextFieldFocused = false;
      this.$emit("isTextFieldFocused", this.isTextFieldFocused);
      const inputid = document.getElementById("text-input");
      inputid.blur();
      if (this.onLine === false) {
        // toast({ text: this.$t("licence.key_internet_error"), time: 1000 });

        if (window.webkit != undefined) {
          let text = this.$t("licence.key_internet_error");
          window.webkit.messageHandlers.showToast.postMessage(text);
        } else {
          let text = this.$t("licence.key_internet_error");
          feedback.showToast(text);
        }
      } else {
        this.isTextFieldFocused = false;
        // toast({text:"不能发送空消息哦",time:1000})
        this.onInputButtonHoverLeave();
        this.textInput = this.textInput.trim();

        // empty string
        if (!this.textInput.length) {
          if (window.webkit != undefined) {
            let text = this.$t("licence.Robot_emptyMassege_reminder");
            window.webkit.messageHandlers.showToast.postMessage(text);
          } else {
            let text = this.$t("licence.Robot_emptyMassege_reminder");
            feedback.showToast(text);
          }
        }

        const message = {
          type: "human",
          text: this.textInput,
        };

        return this.$store.dispatch("postTextMessage", message).then(() => {
          this.textInput = "";
          if (this.shouldShowTextInput) {
            this.setInputTextFieldFocus();
          }
        });
      }
    },
    onEndLiveChatClick() {
      this.shouldShowEndLiveChatTooltip = false;
      this.$emit("endLiveChatClicked");
    },
    startSpeechConversation() {
      if (this.isMicMuted) {
        return Promise.resolve();
      }
      return this.setAutoPlay()
        .then(() => this.playInitialInstruction())
        .then(() => this.$store.dispatch("startConversation"))
        .catch((error) => {
          console.error("error in startSpeechConversation", error);
          const errorMessage = this.$store.state.config.ui.showErrorDetails
            ? ` ${error}`
            : "";

          this.$store.dispatch(
            "pushErrorMessage",
            "Sorry, I couldn't start the conversation. Please try again." +
              `${errorMessage}`
          );
        });
    },
    /**
     * Set auto-play attribute on audio element
     * On mobile, Audio nodes do not autoplay without user interaction.
     * To workaround that requirement, this plays a short silent audio mp3/ogg
     * as a reponse to a click. This silent audio is initialized as the src
     * of the audio node. Subsequent play on the same audio now
     * don't require interaction so this is only done once.
     */
    setAutoPlay() {
      if (this.$store.state.botAudio.autoPlay) {
        return Promise.resolve();
      }
      return this.$store.dispatch("setAudioAutoPlay");
    },
  },
};
</script>
<style  scoped>
.input-container {
  /* make footer same height as dense toolbar */
  /* top:-5vw; */
  /* margin-top: -30vw; */
  min-height: 48px;
  position: fixed;
  /* bottom: 0; */
  bottom: env(safe-area-inset-bottom);
  left: 0;
  left: env(safe-area-inset-left);
  right: 0;
  right: env(safe-area-inset-right);
}

.container {
  flex-grow: 0;
  flex-shrink: 0;
  box-sizing: border-box;
  padding: 0;
}

.styleChange {
  display: flex;
  background-color: #f3f3f3;
  border-radius: 5.5pt;
  padding-left: 3vw;
  height: 12vw;
  margin-bottom: 15pt;
  margin-left: 4vw !important;
  margin-top: 9.5vw;
}

.placeholder {
  color: #c1c1c1;
  margin-top: -1vw;
}

.select-panel {
  height: 0;
  z-index: 999;
  background-color: red !important;
  display: flex;
  flex-direction: column-reverse;
}

.select-item {
  /* height: 190vw !important; */
  z-index: 999;
  /* margin-top: 1px; */
  /* border-bottom: 1px solid #E2E2E2; */
  padding: 2vw;
  /* padding-bottom: 13vw; */
  /* width: 50vw; */
  /* font-size: 5vw; */
  background: #f3f3f3;
  opacity: 1;
  /* margin-left: 2vw; */
}

.select-item::after {
  content: "";
  width: 98%;
  /* height: 10px; */
  display: block;
  margin: 0 auto;
  margin-top: 3vw;
  border-bottom: 1px solid #e2e2e2;
}

.select-item:first-child::after {
  border-bottom: none;
}

.wrapper {
  display: flex;
  align-items: center;
  justify-content: center;
  height: 100%;
}

.block {
  width: 120px;
  height: 120px;
  background-color: #fff;
}

.menuContainer {
  display: flex;
  flex-direction: column;

}

.menuCard {
  border-radius: 4vw;
  width: 50vw;
  position: absolute;
  top: 137vw;
  right: 5vw;
}

.menuBtn {
  background-color: #fff;
}

.menu {
  display: flex;
  flex-direction: row;
  align-items: center;
  /* justify-content: space-evenly; */
  height: 10vw;
  /* border-bottom: 1px; */

}


.vdialognew {
  background-color: red;
  box-shadow: none;
}

.menuBtn:active {
  background-color: #f3f3f3;
}

/deep/.dialog.foo.dialog--active {
  background-color: red;
  box-shadow: none;
}

/deep/.input-group__details {
  display: none;
}

/deep/.btn__content {
  margin-top: 0vw;
}

/deep/.dialog {
  background-color: red;
  width: 8%;
}

/deep/ * {
  -webkit-touch-callout: none; /*系统默认菜单被禁用*/
  -webkit-user-select: auto; /*webkit浏览器*/
  -khtml-user-select: none; /*早期浏览器*/
  -moz-user-select: none; /*火狐*/
  -ms-user-select: none; /*IE10*/
  user-select: none;
}

/* .line {
width: 41vw;
height: 0vw;
border: 0.1vw solid #EEEEEE;
} */
</style>
 <style >
::v-deep .vdialognew {
  background-color: red;
  box-shadow: none;
}

/deep/ .dialog .vdialognew .dialog--active .dialog--persistent {
  background-color: red;
}
</style>

